import { Button } from "@mui/material";
import Styled from "styled-components";
import { respondTo } from "../../respondTo";


export const SectionTitle = Styled.h1<{color?: string , mg?: string, pd?:string}>`
        color: ${props => props.color ?  props.color : "var(--on-surface-dark)"};
        transition: color 0.3s ease-in-out;
        margin: ${({mg}) => mg ? mg : ""};
        padding: ${({pd}) => pd ? pd : ""};
        ${respondTo.desktop`
        padding: ${({pd}:any) => pd ? pd : ""};
        margin: ${({mg}:any) => mg ? mg : ""};
    `} 
`;

export const P = Styled.p <{color?: string }>`
    color:  ${props => props.color ?  props.color : "var(--on-surface-dark)"};
     transition: color 0.3s ease-in-out;
    display: block;
    padding-top: 1.25rem;

        /* ${respondTo.tablet_landscape_s`
        padding-top: 2.5rem;
        `} */
    
       ${respondTo.desktop`
        padding-top: 2.5rem;
    `}
`;


export const TitleContainer = Styled.div<{display?: string, jContent?:string , aItem?:string, fDirection?:string , padding?:string }>`
    padding:    ${({padding })  => padding? padding : ""};
    width: 100%;
    display: ${props => props.display? props.display : ""};
    justify-content: ${props => props.jContent? props.jContent : ""};
    align-items: ${props => props.aItem? props.aItem : ""};
    flex-direction: ${props => props.fDirection? props.fDirection : ""};
    max-width: 1512px;
      
      ${respondTo.tablet_landscape_s`
        display: flex;
        flex-direction: ${({fDirection } : any)  => fDirection? fDirection : "column"};
        justify-content: ${({jContent } : any)  => jContent? jContent : "center"};
        align-items: ${({aItem } : any)  => aItem? aItem : "center"};
        text-align: ${({aItem } : any)  => aItem? aItem : "center"};
        padding-bottom: ${({padding } : any)  => padding? padding : "2.625rem 1.35rem 0 1.25rem"};  
        
    `} 
    `

export const StyledButton = Styled(Button)<{ selecteditem ?: number , mg?:string  }>`
    color : ${({selecteditem}) => selecteditem === 0 ? "var(--on-primary-dark)" : "var(--on-primary-light)"};
    transition: color 0.3s ease-in-out;
    background-color: ${({selecteditem}) => selecteditem === 0 ?  "var(--primary-dark)" : "var(--primary-light)"};
    transition: background-color 0.3s ease-in-out;
    margin :  ${({mg}) => mg ? mg : ""};
    &:hover {
        background-color: ${({selecteditem}) => selecteditem === 0 ? "var(--primary-dark)" : "var(--primary-light)"};
    }
    border-radius: 2rem;
    padding: 0.5rem 1rem;
    text-transform: none;
`;

